import { usePrefs } from 'wsm-common-data';
import { DISPLAY_MODE } from '../global-constants';

/**
 * True when this widget is being embedded chromeless -- no own icon
 * button, no own frame -- by a host that controls presentation itself
 * (the drawer's header-icon popup, or its inline mobile panel). Reads
 * displayMode directly via usePrefs so any component can ask this without
 * it being threaded down as a prop from Widget.
 */
export const useIsChromeless = () => {
	const { displayMode } = usePrefs();
	return (
		displayMode === DISPLAY_MODE.HEADLESS_MODAL ||
		displayMode === DISPLAY_MODE.INLINE_CONTENT
	);
};
